import { Fragment } from 'vue-fragment';
import WSIcon from '@dengl/common/components/ws-icon.vue';

const lookup = {
	travelCompanions: [null, 'family', 'friends', ['partner', 'couple']],
	activity: [null, 'ski', 'snowboard', 'langlauf'],
	experience: [
		null,
		['beginner', 'medal'],
		['moderate', 'medal'],
		['advanced', 'medal'],
		['expert', 'medal']
	]
};

export default {
	functional: true,
	render(createElement, context) {
		const children = [];

		Object.keys(lookup).forEach(type => {
			if (Object.prototype.hasOwnProperty.call(context.props.review, type)) {
				let value = lookup[type][context.props.review[type]];
				if (value) {
					let icon = value;
					if (typeof value !== 'string') {
						[value, icon] = value;
					}
					children.push(
						createElement(
							'v-chip',
							{
								class: ['mr-1', 'grey--text'],
								props: { small: true, label: true, color: 'grey lighten-4' }
							},
							[
								createElement(WSIcon, { props: { small: true, left: true } }, [
									icon || value
								]),
								'',
								context.parent.$t(`review:review_meta.${value}`)
							]
						)
					);
				}
			}
		});

		return createElement(Fragment, context.data, children);
	}
};
